import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert, Snackbar} from "@mui/material";
import {closeToast, selectToastOptions, selectToastState} from "../../store/global/toastSlice";

function GlobalToast() {
    const dispatch = useDispatch();
    const state = useSelector(selectToastState);
    const options = useSelector(selectToastOptions);

    return (
        <Snackbar
            {...options}
            open={state}
            onClose={() => dispatch(closeToast())}>

            <Alert
                onClose={() => dispatch(closeToast())}
                severity={options.variant}
                variant="filled"
                sx={{width: '100%'}}>
                {options.message}
            </Alert>

        </Snackbar>
    );
}

export default React.memo(GlobalToast);
